import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { Icon, Initials, InfoText } from '@weezevent/nacre';

import Style from './listItem.module.css';

export default function ListItem({ className = '', subtitle = null, content = null, url = '', icon = null, children = null, status = null, deleted = false, onClick = () => {} }) {
    return (
        <Link to={url} onClick={onClick} className={`${Style['list-item__container']} ${deleted ? Style['list-item__deleted'] : ''} ${className}`}>
            <div className={`${Style['list-item__container-label']} ${icon ? Style['list-item__align-flex-start'] : ''}`}>
                {icon && <span className={Style['list-item__icon-left']}>{icon}</span>}
                {content && <Initials content={content} size="medium" className={Style['list-item__initials']} />}
                <InfoText className={!status ? Style['list-item__infotext'] : Style['list-item__infotext-w-status']} subtitle={subtitle}>
                    {children}
                </InfoText>
            </div>
            <div className={Style['list-item__content-right']}>
                {status && <div className={Style['list-item__status']}>{status}</div>}
                <Icon name="chevron-right" className={Style['list-item__icon-right']} />
            </div>
        </Link>
    );
}

ListItem.propTypes = {
    children: PropTypes.node,
    title: PropTypes.node,
    className: PropTypes.string,
    content: PropTypes.string,
    url: PropTypes.string,
    icon: PropTypes.node
};
